// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1HYAq","label":"Category_label__3sFKC","content":"Category_content__27Zno","header":"Category_header__3dnES","location":"Category_location__3qDms"};